import { useCallback } from 'react'
import { GlobalEvents } from '@highlight/ipc'
import { Toast } from '../components/toast'
import { toastManager } from '../toast-store'

interface ClientToolApprovalToastProps {
  toastId: string
  requestId: string
  toolset: string
  tool: string
  input: Record<string, unknown>
  onRespond: () => void
}

export function ClientToolApprovalToast({
  toastId,
  requestId,
  toolset,
  tool,
  input,
  onRespond,
}: ClientToolApprovalToastProps) {
  const respond = useCallback(
    (approved: boolean) => {
      onRespond()
      GlobalEvents.emit(`client-tool:approval-response:${requestId}`, { approved })
      toastManager.dismiss(toastId)
    },
    [requestId, toastId, onRespond],
  )

  const summary = `Will run on your computer. Do you approve?`
  const title = input.title as string | undefined

  return (
    <Toast toastId={toastId}>
      <Toast.Content>
        {(title || summary) && (
          <div className="flex flex-col gap-1">
            {title && <div className="text-foreground text-sm font-medium">{title}</div>}
            {summary && <Toast.Description>{summary}</Toast.Description>}
          </div>
        )}
        <Toast.Actions
          keepToastOpen
          actions={[
            {
              variant: 'secondary',
              children: 'Deny',
              onClick: () => respond(false),
            },
            {
              variant: 'primary',
              tone: 'success',
              children: 'Approve',
              onClick: () => respond(true),
            },
          ]}
        />
      </Toast.Content>
    </Toast>
  )
}
